<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2023-12-12 15:27:06
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
 box-sizing: border-box; 
}
.container {
    width: 100%;
    background-color: #F5F7FB;
    padding: 0 20px 20px;
    min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue